export default "__VITE_ASSET__fba76dd4__"